import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsGuard {
  // -----------------------------------------------------------------------------------------------------
  // @ Local variables
  // -----------------------------------------------------------------------------------------------------
  private readonly INTEGRATIONS_SUFFIX_URL = {
    LOAD_SHAREPOINT: 'load_sharepoint_sites',
  };
  /**
   * Constructor
   *
   * @param {Router} _router
   */
  constructor(private _router: Router) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * CanActivate
   *
   * @param activatedRoute
   * @returns boolean
   */
  canActivate(activatedRoute: ActivatedRouteSnapshot): boolean | UrlTree {
    const sharePointParam = this.INTEGRATIONS_SUFFIX_URL.LOAD_SHAREPOINT;
    const hasQueryParam = activatedRoute.queryParamMap.has(sharePointParam);

    if (activatedRoute.queryParams[sharePointParam] === 'true' && hasQueryParam) {
      this._router.navigate(['/settings/integrations/one-drive']);
      return true;
    }

    return true;
  }
}
